import { render, staticRenderFns } from "./dashboardMaster.vue?vue&type=template&id=28f61b32&"
import script from "./dashboardMaster.vue?vue&type=script&lang=js&"
export * from "./dashboardMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports